export default {
  locale: 'fr',
  messages: {
      actions: 'Actions',
      add: 'Ajouter',

      addressAddNew: 'Ajouter une nouvelle adresse',
      addressChangeAddress: 'Choisir une autre adresse',
      addressCity: 'Ville',
      addressCountry: 'Pays',
      addressDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cette adresse ?',
      addressDeleteConfirmTitle: 'Suppression d\'une adresse',
      addressDeleteSuccess: 'Adresse supprimée !',
      addressEdit: 'Éditer l\'adresse',
      addressesMyManage: 'Gérer mes adresses',
      addressInvoice: 'Adresse de facturation',
      addressInvoiceCountry: 'Pays de facturation',
      addressInvoiceSameAsShippingLabel: 'Les données de facturation sont-elles indentiques à celles de livraison ?',
      addressInvoiceUsedFor: 'Défini en tant qu\'adresse de facturation',
      addressInvoiceUsedForSuccess: 'Adresse de facturation mis à jour !',
      addressLabel: 'Intitulé de l\'adresse (ex: Maison)',
      addressMy: 'Mes adresses',
      addressMyViewButton: 'Voir mes adresses',
      addressName: 'Prénom et nom du destinataire',
      addressNameAlt: 'Nom de l\'entreprise (Si livraison au travail)',
      addressNoItems: 'Vous n\'avez pas encore enregistré d\'adresse !',
      addressPhone: 'Téléphone (utile pour la livraison)',
      addressPostalCode: 'Code postal',
      addressRegion: 'Région',
      addressSavedCountryError: 'Ce pays n\'est pas autorisé !',
      addressSavedSuccess: 'Adresse enregistrée !',
      addressSelectOptions: 'Choisissez une adresse',
      addressShipping: 'Adresse de livraison',
      addressShippingCountry: 'Pays de livraison',
      addressStreet1: 'Adresse',
      addressStreet2: 'Appartement, digicode, interphone, ...',
      addressUserCount: `Vous avez {count} {count, plural,
          =0 {adresse}
          =1 {adresse}
          other {adresses}
      } {count, plural,
          =0 {enregistrée}
          =1 {enregistrée}
          other {enregistrées}
      } dans votre compte.`,

      administrationTitle: 'Administration',

      alertFetchApiError: 'Le serveur est actuellement hors service...',
      alertFormRequiredFieldsError: 'Veuillez remplir tous les champs obligatoires !',
      alertGenericError: 'Une erreur s\'est produite ! Veuillez essayer plus tard...',
      alertJsonParseError: 'Le serveur a retourné une mauvaise réponse...',
      alertUnauthorized: 'Votre session a expirée ! Veuillez vous reconnecter s\'il vous plaît',

      alertContactError: 'Impossible d\'envoyer votre message ! Veuillez réessayer...',
      alertContactSuccess: 'Bien reçu !',

      alertUserAlreadyExists: 'Un compte existe déjà avec cette adresse email !',
      alertUserRegisterSuccess: 'Bienvenue ! Veuillez vous connecter avec votre mot de passe temporaire reçu sur votre boîte email {user}',

      app404ErrorTitle: 'Mauvaise route...',
      appAccessButton: 'Accéder à {app}',
      appAdvantagesFabrication: 'Fabriqué en Europe',
      appAdvantagesFreeShipping: 'Livraison gratuite en Europe',
      appAdvantagesInternationalShipping: 'Livraison internationale',
      appAdvantagesSecurePayment: 'Paiement sécurisé',
      appConditionsAcceptTitle: 'Conditions générales d\'utilisation',
      appConditionsCheckError: 'Veuillez cocher avoir pris connaissance des conditions générales d\'utilisation !',
      appConditionsCheckLabel: 'J\'ai lu et j\'accepte les conditions générales d\'utilisation',
      appConditionsCheckSuccess: 'Bien reçu !',
      appConditionsUpdateDate: 'Mise à jour le {date}',
      appCookieConsentText: 'En poursuivant votre navigation sur ce site, vous acceptez l’utilisation de cookies à des fins de bon fonctionnement du service proposé et de statistiques. Aucune donnée personnelle ne sera communiquée sans votre accord préalable.',
      appCookieConsentPrivacyLink: 'Consultez notre politique de confidentialité',
      appForceUpdateApp: 'Forcer la mise à jour de l\'application',
      appHome: 'Accueil',
      appVersionCurrent: 'Version actuelle de l\'application: {version}',

      back: 'Retour',
      by: 'par',

      cancel: 'Annuler',

      cartAddToButton: 'Ajouter au panier',
      cartBackToHomeButton: 'Continuer sur le site',
      cartConfirmationText: 'Vous allez recevoir un email de confirmation, <br />Votre commande sera visible et vous pourrez la suivre via <a href="{link}">votre compte</a>.',
      cartConfirmationTitle: 'Merci ! <br />Votre commande <a href={link} class="text-warning text-underline">{orderNumber}</a> est validée.',
      cartConfirmationSubText: 'Venez échanger sur les réseaux sociaux',
      cartDeliveryTitle: 'Livraison',
      cartEmptyError: 'Votre panier est vide...',
      cartInvoiceAddressSelectionTitle: 'Sélectionnez votre adresse de facturation',
      cartItemProductPackPriceAlertTitle: 'Prix dégressifs',
      cartItemProductPackPriceAlertText: 'Augmentez le nombre de boîtes pour profiter de tarifs avantageux',
      cartLegalMentionText: 'En validant votre commande vous reconnaissez avoir pris connaissance des <a href="{link}" target="_blank">CGV</a> et vous en acceptez les termes',
      cartNextButton: 'Suivant',
      cartNotValidError: 'Veuillez vérifier votre panier avant de poursuivre !',
      cartPayButton: 'Effectuer le paiement',
      cartPaymentBankTransferLabel: 'Je paie par virement bancaire',
      cartPaymentCreditCardLabel: 'Je paie en carte bancaire',
      cartPaymentPaypalLabel: 'Je paie avec Paypal',
      cartPendinpPaymentText: 'Nous n\'attendons plus que votre paiement pour traiter votre commande...',
      cartStepPaymentTitle: 'Votre paiement',
      cartStepPaymentInfoText: 'Bravo, on y est presque !<br />Renseignez votre mode de paiement.',
      cartStepPreviewTitle: 'Votre panier',
      cartStepPreviewInfoText: 'Vous voilà dans votre panier.<br />Pensez à nos tarifs dégressifs.',
      cartStepShippingTitle: 'Vos coordonnées',
      cartStepShippingInfoText: 'Vérifiez votre adresse de livraison <br />et tous les détails nécessaires pour le transporteur',
      cartShippingAddressMissingError: 'Vous n\'avez pas renseigné votre adresse de livraison !',
      cartShippingAddressSelectionTitle: 'Sélectionnez votre adresse de livraison',
      cartShippingCalculatedTitle: 'Livraison et TVA',
      cartShippingCalculationText: 'Renseignez votre pays de livraison',
      cartShippingCalculationTitle: 'Calculez vos frais d\'expédition et de TVA.',
      cartShippingCalculationListButton: 'Pays de livraison',
      cartShippingSetAlert: 'Vous souhaitez vous faire livrer en {country}',
      cartShippingUnavailableAlert: 'Nous ne pouvons livrer dans votre région !',
      cartShippingUnavailableLink: 'Voir la liste des pays',
      cartShippingValidateDetails: 'Valider les coordonnées de livraison',
      cartTotalNotSet: 'Non applicable',
      cartTotalShipping: 'Expédition',
      cartTotalShippingFree: 'Gratuite',
      cartTotalSubTotal: 'Sous-total',
      cartTotalTax: 'TVA',
      cartTotalTaxNotSet: 'Choisissez votre pays de livraison',
      cartTotalTotal: 'Total',
      cartVoucherApplyTitle: 'Code Promo',

      checkToggler: 'Tout Sélectionner/Déselectionner',
      choose: 'Choisir',
      close: 'Fermer',

      cms: 'CMS',
      cmsContentEdit: 'Édition de contenu',
      cmsContentIsActive: 'Contenu activé ?',
      cmsContentModelLabel: 'Modèle',
      cmsContentSlug: 'Chemin d\'accès',
      cmsContentTitle: 'Titre',
      cmsContentTranslations: 'Traductions',
      cmsContentTypeLabel: 'Type de contenu',
      cmsPageSeoDescription: 'Description SEO',
      cmsPageSeoKeywords: 'Mot-clés SEO',
      cmsPageSeoTitle: 'Titre SEO',
      cmsPanelIsTemplate: 'Inclus dans le thème',

      configuration: 'Configuration',

      contactByEmail: 'Par email',
      contactFormIdentityTitle: 'Identité',
      contactInfoText: 'Pour toutes questions sur notre produit ou votre commande',
      contactNeedHelpTitle: 'Besoin d\'aide ?',
      contactPageButton: 'Envoyer',
      contactPageTitle: 'Contactez-nous',
      contactPageText1: 'Besoin d\'aide ? D\'information ? Nous sommes là pour vous aider !',
      contactSendButton: 'Envoyer le message',
      contactTitle: 'Contact',
      contactUsByPhone: 'Contactez-nous au',

      continue: 'Poursuivre',

      country: 'Pays',
      countryFillPlaceholder: 'Entrez un pays puis tapez sur "entrée"',
      countrySelectPlaceholder: 'Sélectionner un pays',

      dateActivated: 'Date d\'activation',
      dateCreated: 'Date de création',
      dateCreation: 'Date de création',
      dateLastCguAccept: 'Date de dernière validation des CGU',
      dateLastEdit: 'Date de dernière modification',
      dateLastLogin: 'Date de dernière connexion',
      dateLastOrder: 'Date de dernière commande',

      dateSelect: 'Sélectionner une date',
      dateSelectPlaceholder: 'Cliquez ici pour sélectionner une date...',

      dashboardTitle: 'Tableau de bord',

      date: 'Date',
      dateThe: 'le {date}',
      days: 'Jour(s)',

      delete: 'Supprimer',
      deleteRequestError: 'Erreur de suppression !',
      deleteRequestSuccess: 'Supprimé !',

      domain: 'Domaine',

      download: 'Télécharger',

      edit: 'Modifier',
      editViewAdvanced: 'Édition avancée',
      editViewSimplified: 'Édition simplifiée',
      elementsCount: `{count} {count, plural,
          =0 {élément}
          =1 {élément}
          other {éléments}
      }`,
      elementNoItems: 'Aucun élément',

      example: 'Exemple',
      examples: 'Exemples',

      file: 'Fichier',
      fileDeleteError: 'Impossible de supprimer ce fichier',
      fileDeleteSuccess: 'Fichier supprimé !',
      files: 'Fichiers',
      fileUploadError: 'Impossible de charger ce fichier !',
      fileUploadProcessStartOnSave: 'Le chargement du fichier démarrera à la sauvegarde.',
      fileUploadSuccess: 'Fichier uploadé !',
      fileUploadRestrictionTypeError: 'Format de fichier non accepté ! Autorisé: {types}',

      filtersTitle: 'Filtres',

      finish: 'Terminer',

      formFieldRequired: 'Ce champ est requis !',
      formFieldValidEmail: 'Veuillez entrer une adresse email valide !',

      generalInformation: 'Informations générales',

      help: 'Aide',

      hours: 'Heures',

      imageDeleteError: 'Impossible de supprimer cette image !',
      imageDeleteSuccess: 'Image supprimée !',
      imageUploadError: 'Impossible de charger cette image',
      imageUploadRestrictionSize: 'L\'image doit avoir un format de {format} maximum',
      imageUploadRestrictionType: 'L\'image doit être en {types}',
      imageUploadRestrictionTypeError: 'Format d\'image non accepté ! Autorisé: {types}',

      import: 'Importer',
      importerFileInfo: 'Sélectionner un fichier CSV (Valeurs séparées par des virgules)',
      importerFileHelp: 'Vous pouvez générer un fichier CSV à l\'aide de votre logiciel d\'édition de tableur (Excel, OpenOffice, ...)',
      importerNoItemsAlert: 'Aucun élément à importer',
      importerTitle: 'Import de données',
      importerFileButton: 'Importer les données',
      importModelDownloadButton: 'Téléchargez le modèle',
      importRequestError: 'Une erreur est apparue lors de l\'importation !',
      importRequestSomeFailAlert: 'Une ou plusieurs entrées n\'ont pu être importées !',
      importRequestSuccess: 'Données importées !',

      information: 'Information',
      informationsDetails: 'Détails',
      informationsGeneral: 'Informations générales',

      isActive: 'Actif ?',
      isPublic: 'Public ?',
      isUnlimited: 'Illimité ?',

      label: 'Intitulé',

      langDE: 'Deutsh',
      langEN: 'English',
      langES: 'Español',
      langFR: 'Français',
      language: 'Langue',

      learnMore: 'En savoir plus',

      listTitle: 'Liste',

      loading: 'Chargement...',
      loadMore: 'Charger plus...',
      logo: 'Logo',

      matter: 'Matière',

      minutes: 'Minute(s)',

      name: 'Nom',
      next: 'Suivant',

      newsletterInfoText: 'Envie d\'en savoir plus, de profiter d’offres exclusives ? Inscrivez-vous à notre lettre d\'information',
      newsletterTitle: 'Newsletter',

      no: 'Non',

      options: 'Options',

      orderAdd: 'Ajouter une commande',
      orderBuyButton: 'Acheter',
      orderCartLink: 'Panier',
      orderCreationError: 'Nous ne pouvons créer votre commande pour le moment... Merci de nous contacter !',
      orderCreationProcessing: 'Nous créons votre commande...',
      orderFlags: 'Drapeaux',
      orderItems: 'Contenu',
      orderInformationDetails: 'Détails de la commande',
      orderInvoice: 'Facture',
      orderInvoiceDate: 'Date de facture',
      orderInvoiceNumber: 'Numéro de facture',
      orderInvoicePrintButton: 'Imprimer la facture',
      orderMy: 'Ma commande',
      ordersMyViewButton: 'Voir mes commandes',
      ordersMy: 'Mes commandes',
      orderNoElements: 'Vous n\'avez pas encore commandé !',
      orderPaymentFinishTitle: 'Poursuivre mon paiement',
      orderPaymentMethod: 'Mode de paiement',
      orderPaymentMethodBanktransfer: 'Virement bancaire',
      orderPaymentMethodCreditcard: 'Carte de paiement',
      orderPaymentMethodPaypal: 'Paypal',
      orderPaymentProcessButton: 'Effectuer le paiement',
      orderPaymentProcessing: 'Nous collectons les données pour votre paiement...',
      orderPayments: 'Paiements',
      orderPaymentStatusPending: 'En attente',
      orderPaymentStatusComplete: 'Terminé',
      orderPaymentUnavailableAlert: 'Mode de paiement non disponible... Veuillez nous contacter pour effectuer votre paiement.',
      orderPaymentValidButton: 'Valider le paiement',
      orderPaymentValidSuccess: 'Paiement validé',
      orderProductAdd: 'Ajouter un produit',
      orderReOrderButton: 'Renouveler ma commande',
      orders: 'Commandes',
      orderShippings: 'Expéditions',
      orderStatusArchived: 'Archivée',
      orderStatusCanceled: 'Annulée',
      orderStatusComplete: 'Terminée',
      orderStatusOnpreparation: 'En préparation',
      orderStatusPendingpayment: 'En attente de paiement',
      orderStatusShipped: 'Expédiée',
      orderSubscribeButton: 'S\'abonner',
      orderTotal: 'Total',
      orderUserCount: `Vous avez {count} {count, plural,
          =0 {commande}
          =1 {commande}
          other {commandes}
      }`,
      orderWeight: 'Poids de la commande',

      Page404ErrorTitle: 'Nous n\'avons pas trouvé ce que vous cherchez...',

      priceHT: 'Prix HT',
      priceTTC: 'Prix TTC',

      previous: 'Précédent',

      productAdd: 'Ajouter un produit',
      productAddedSuccess: '{product} ajouté !',
      productCodeEAN: 'Code EAN',
      productComposition: 'Composition',
      productDescription: 'Description',
      productDuplicateSuccess: 'Produit dupliqué !',
      productEdit: 'Modifier le produit',
      productImageSaveBeforeAlert: 'Vous devez enregistrer ce produit avant d\'ajouter une image !',
      productName: 'Nom',
      productPackChoiceTitle: 'Découvrez nos packs',
      productPackFreeCount: `+{count} {count, plural,
          =0 {boîte}
          =1 {boîte}
          other {boîtes}
      } {count, plural,
          =0 {OFFERTE}
          =1 {OFFERTE}
          other {OFFERTES}
      }`,
      productPackMonthlyConsumptionLabel: 'Conseillé pour 1 mois',
      productPackUnitPrice: 'Soit {price}/boîte',
      productPriceInformation: 'Tarifs',
      products: 'Produits',
      productSelectOptions: 'Sélectionner un produit',
      productSlug: 'Chemin',
      productSpoonLabel: 'La cuillère doseuse',
      productSpoonOffer: 'en cadeau',
      productSubTotal: 'Prix TTC',
      productTaxCalculate: 'Calculer',
      productTaxRate: 'Taux de taxe',
      productTaxRateTaxCalculation: 'Ou {amount}€ de TVA',
      productUnitLabel: 'boîte',
      productUnitCountLabel: `{count} {count, plural,
          =0 {boîte}
          =1 {boîte}
          other {boîtes}
      }`,

      quantity: 'Quantité',

      refresh: 'Rafraichir',
      remove: 'Supprimer',
      retry: 'Recommencer',

      reviewAddFirstReviewButton: 'Déposer mon avis',
      reviewAddFirstReviewText: 'Vous aimez notre produit ? Vous souhaitez partager votre retour d\'expérience avec nos clients ? Partagez votre expérience ! Cela ne vous prendra que 2 minutes !',
      reviewAddFirstReviewTitle: 'Évaluez notre produit !',
      reviewAddLoading: 'Nous enregistrons votre avis...',
      reviewAddSuccess: 'Nous avons bien reçu votre avis ! Il sera affiché après modération....',
      reviewAnswer: 'Réponse d\'Atremoplus',
      reviewFilterClear: 'Réinitialiser les filtres',
      reviewFilterLabel: 'Trier les témoignages',
      reviewFilterLanguageLabel: 'Par langue',
      reviewLink: 'Copiez le lien de votre vidéo',
      reviewLinkHelp: 'Enregistrez votre vidéo sur Youtube (par exemple) puis copiez le lien de la vidéo dans le champ ci-dessus.',
      reviewLinkViewButton: 'Voir le lien',
      reviewName: 'Nom et pays',
      reviews: 'Avis',
      reviewScoreLabel: 'Choisissez votre note',
      reviewSummaryButton: 'Découvrir leurs témoignages',
      reviewSummaryTitle: 'Nos clients en parlent le mieux, découvrez leurs avis !',
      reviewText: 'Entrez votre avis...',
      reviewTitle: 'Titre de votre avis',
      reviewTypeLinkLabel: 'Média',
      reviewTypeTextLabel: 'Texte',

      save: 'Enregistrer',
      saveBeforeAlert: 'Veuillez enregistrer d\'abord...',
      saveRequestError: 'Erreur d\'enregistrement !',
      saveRequestSuccess: 'Enregistré !',
      saving: 'Enregistrement...',

      searchFor: 'Rechercher',

      seconds: 'Seconde(s)',

      selectAll: 'Tout sélectionner',
      selectUnAll: 'Tout désélectionner',
      selectFile: 'Sélectionner un fichier',
      selectImage: 'Sélectionnez une image',
      selectOptions: 'Sélectionner une option',

      seoTitle: 'Complément L-Dopa naturelle',

      shippingFeeAmountLabel: 'Montant',
      shippingFeeCarrierLabel: 'Transporteur',
      shippingFeeCountriesLabel: 'Pays sélectionnées',
      shippingFeeExcludeDepartmentInfo: 'Séparez les codes par une virgule (,). Utilisez "*" comme joker.',
      shippingFeeExcludeDepartmentLabel: 'Code postaux à exclure',
      shippingFeeFreeThresholdInfo: 'Définissez cette valeur à 0 pour désactiver la livraison offerte',
      shippingFeeFreeThresholdLabel: 'Montant minimum à atteindre pour appliquer la livraison offerte',
      shippingFeeHasExcludeConditions: 'Avec exceptions',
      shippingFees: 'Frais de livraison',
      shippingFeeTrackingUrlInfo: 'Vous pouvez ajouter \'{trackingNumber}\' à l\'url pour inclure le numero de suivi automatiquement.',
      shippingFeeTrackingUrlLabel: 'Url de suivi',

      status: 'Statut',
      stepTitle: 'Étape {step}',

      subscription: 'Abonnement',
      subscriptionCartButton: 'Je m\'abonne sans engagement',
      subscriptionCartText: 'Pensez à l\'abonnement: Choisissez votre période, votre pack, SANS engagement et facile à souscrire !',
      subscriptionCancelSuccess: 'Votre abonnement a été annulé !',
      subscriptionCancelSuccessDeffered: 'Nous allons annuler votre abonnement dès que possible !',
      subscriptionConfigurationPackTitle: 'Choix du pack',
      subscriptionConfigurationPeriodTitle: 'Choix de la périodicité',
      subscriptionConfigurationTitle: 'Configurez votre abonnement',
      subscriptionCreateButton: 'Je m\'abonne sans engagement',
      subscriptionPeriod1Month: '1 mois',
      subscriptionPeriod6Week: '6 semaines',
      subscriptionPeriod2Month: '2 mois',
      subscriptionRemoveButton: 'Je ne souhaite pas m\'abonner pour le moment',
      subscriptionResumeText: `Vous avez choisi un abonnement de {count} {count, plural,
          =0 {boîte}
          =1 {boîte}
          other {boîtes}
      } chaque {period}`,
      subscriptionResumeText2: `Abonnement de {count} {count, plural,
          =0 {boîte}
          =1 {boîte}
          other {boîtes}
      } chaque {period}`,
      subscriptionResumeTitle: 'Votre abonnement',
      subscriptionStopButton: 'Arrêter l\'abonnement',

      submit: 'Soumettre',
      switch: 'Changer',
      switchLanguage: 'Changer de langue',

      tableMassActions: 'Actions groupées',
      tableRefreshSuccessError: 'Erreur de synchronisation !',
      tableRefreshSuccessAlert: 'Synchronisé !',
      tableSelection: `{count} {count, plural,
          =0 {sélectionné}
          =1 {sélectionné}
          other {sélectionnés}
      }`,

      tag: 'Mot-clé',
      tags: 'Mot-clés',
      tagFillPlaceholder: 'Entrez un mot-clé et appuyez sur "entrée"...',

      taxes: 'Taxes',
      taxCountriesLabel: 'Pays sélectionnés',
      taxHasCustomsFees: 'Frais de douanes ?',
      taxHasCustomsFeesInfo: 'Avec frais de douanes',
      taxRate: 'TVA',
      taxRateLabel: 'Taux de taxe',
      taxThresholdLabel: 'Montant minimum pour appliquer le taux',

      time: 'Heure',
      timezone: 'Fuseau horaire',

      the: 'le',
      title: 'Titre',

      total: 'Total',

      type: 'Type',

      unit: 'Unité',

      user: 'Utilisateur',
      userAccountDataProtection: 'Protection des données',
      userAccountDataProtectionText1: 'Nous prenons très au sérieux la protection de vos données personnelles, c\'est pourquoi nous nous engageons à les sécuriser et nous les conservons pendant une durée raisonnable et nécessaire au bon déroulement des examens.',
      userAccountDataProtectionText2: 'Nous ne vous demandons uniquement des informations qui sont nécessaires au service et nous nous engageons à ne jamais communiquer à un service tiers ou utiliser vos données personnelles à des fins commerciales sans votre consentement.',
      userAccountDataProtectionText3: 'Si vous souhaitez récupérer vos données ou utiliser votre droit à la portabilité des données, veuillez nous contacter sur {email}',
      userAccountDelete: 'Supprimer mon compte',
      userAccountDeleteBlockText: 'Vous ne pouvez pas supprimer votre compte pour le moment !',
      userAccountDeleteButton: 'Supprimer mon compte',
      userAccountDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer votre compte définitivement ?',
      userAccountDeleteConfirmTitle: 'Supprimer mon compte',
      userAccountDeleteError: 'Impossible de supprimer votre compte !',
      userAccountDeleteSuccess: 'Votre compte a été supprimé ! À bientôt !',
      userAccountDeleteText: 'En supprimant votre compte, vous supprimerez votre accès à vos informations sur ce site. Nous supprimerons vos données personnelles dans notre base de données. Cette action est irréversible !',
      userAccoutDetailsTitle: 'Vos coordonnées',
      userAccountEdit: 'Modifier mon compte',
      userAccountEditSuccess: 'Compte mis à jour',
      userAccountExistTitle: 'Vous possédez déjà un compte ?',
      userAccountHistory: 'Historique',
      userAccountInfo: 'Vos informations ne seront pas rendues publiques !',
      userAccountInfoMyTitle: 'Mes informations',
      userAccountGeneral: 'Général',
      userAccountMy: 'Mon compte',
      userAccountPersonnalInformation: 'Mes informations personnelles',
      userAccountPreferencesInformation: 'Mes préférences',
      userAccountResetError: 'Erreur lors de la réinitialisation du compte !',
      userAccountResetSuccess: 'Compte réinitialisé !',
      userActivityOnLine: 'En ligne',
      userAdd: 'Ajouter un utilisateur',
      userAddNew: 'Ajouter un nouvel utilisateur',
      userChangePasswordSuccess: 'Mot de passe modifié !',
      userConfirmationCode: 'Code de confirmation reçu par email',
      userConfirmationCodeCheckButton: 'J\'ai bien reçu le code pour réinitialiser mon mot de passe',
      userConfirmationCodeError: 'Veuillez renseigner le code de confirmation ! Consultez votre boîte mail !',
      userConnectionInfo: 'Accédez à votre compte pour valider votre commande et invitez vos amis à participer !',
      userCustomerAccountLink: 'Compte client',
      userCustomerNewSubTitle: 'Coordonnées et compte client',
      userCustomerNewTitle: 'Nouveau client ?',
      userCustomerRegisteredSubTitle: 'Connectez-vous',
      userCustomerRegisteredTitle: 'Déjà client',
      userDeleteConfirmation: '{user} a été supprimé !',
      userEdit: 'Modifier {user}',
      userEdit2: 'Modifier l\'utilisateur',
      userEditPassword: 'Modifier mon mot de passe',
      userEmail: 'Adresse email',
      userEmailError: 'Votre adresse email est incorrecte !',
      userEmailFillInfo: 'Entrez votre adresse email',
      userEmailFormInfo: 'Renseignez votre email pour continuer',
      userEmailSwitch: 'Changer d\'adresse email',
      userFillPlaceholder: 'Entrez le nom d\'un utilisateur...',
      userFirstName: 'Prénom',
      userForgotPassword: 'Mot de passe oublié ?',
      userForgotPasswordRetryDateError: 'Vous ne pouvez refaire une demande de mot de passe. Veuillez consultez votre boîte email pour récupérer le code de confirmation.',
      userGroupsTitle: 'Groupes de l\'utilisateur',
      userGroupsFillPlaceholder: 'Entrez le nom d\'un groupe...',
      userHistory: 'Suivi de l\'utilisateur {user}',
      userIsActive: 'Actif ?',
      userLastName: 'Nom',
      userLogin: 'Connexion',
      userLoginAction: 'Se connecter',
      userLoginEmailSelected: 'Connexion avec l\'adresse email: {email}',
      userLoginError: 'Identifiants erronés ! Veuillez réessayer...',
      userLoginFirstButton: 'Première connexion ?',
      userLoginFirstText: 'Consultez votre boîte mail pour récupérer votre mot de passe temporaire. Utilisez ce mot de passe pour votre 1ère connexion. Vous pourrez par la suite modifier votre mot de passe.',
      userLoginIntro: 'Merci de vous identifier pour accéder à votre espace.',
      userLoginNoConnexion: 'Aucune connexion',
      userLoginTitle: 'Connexion',
      userLogout: 'Déconnexion',
      userName: 'Nom',
      userNewPassword: 'Nouveau mot de passe',
      userOldPassword: 'Ancien mot de passe',
      userOptions: 'Options de l\'utilisateur',
      userPassword: 'Mot de passe',
      userPasswordConfirmation: 'Confirmation du mot de passe',
      userPasswordConfirmationError: 'Veuillez renseigner une confirmation identique au mot de passe !',
      userPasswordConfirmationRestriction: 'La confirmation doit être identique au mot de passe renseigné',
      userPasswordDisplayButton: 'Afficher le mot de passe',
      userPasswordEdit: 'Modiier mon mot de passe',
      userPasswordError: 'Veuillez renseiger un mot de passe correcte s\'il vous plaît !',
      userPasswordHideButton: 'Cacher le mot de passe',
      userPasswordResetText: 'Veuillez renseigner votre mot de passe personnel. Confirmez-le et cliquez sur le bouton au dessous.',
      userPasswordRestriction: 'Le mot de passe doit respecter 6 caractères !',
      userPasswordRestrictionAlt: 'Le mot de passe doit respecter 6 caractères !',
      userPasswordTemporaryCheckButton: 'J\'ai bien reçu mon mot de passe provisoire',
      userPhone: 'Téléphone',
      userProfileMy: 'Mon profil',
      userRegister: 'Créer mon compte',
      userReInitPassword: 'Réinitialiser mon mot de passe',
      userRegisterError: 'Impossible de créer votre compte ! Veuillez vérifier votre adresse email et réessayer...',
      userRegisterSuccess: 'Félicitations ! Votre compte a été créé !',
      userResetPasswordAccountButton: 'Réinitialiser le mot de passe du compte',
      userResetPasswordError: 'Impossible de réinitialiser votre mot de passe ! Veuillez essayer plus tard...',
      userResetPasswordInfo: 'Vous allez recevoir un code dans votre boîte mail afin de réinitialiser votre mot de passe.',
      userResetPasswordInfo2: 'Réinitialisez votre mot de passe en renseignant les champs ci-dessous:',
      userResetPasswordSuccess: 'Mot de passe réinitialisé avec succès !',
      userRole: 'Rôle',
      userRoleCustomer: 'Client',
      userRoleAdmin: 'Administrateur',
      users: 'Utilisateurs',
      userSearchLabel: 'Tapez un email ou un nom d\'un utilisateur',
      userSelectPlaceholder: 'Sélectionnez un utilisateur',
      userSendNewAccountEmail: 'Envoyer un email de nouveau compte à l\'utilisateur',
      userSendNewAccountEmailSuccess: 'Utilisateur averti!',
      usersList: 'Liste des utilisateurs',
      userSubscribeNewsletterButton: 'Je m\'abonne',
      userSubscribeNewsletterConfirmation: 'Vous êtes déja inscrit à notre newsletter ! Merci !',
      userSubscribeNewsletterLabel: 'Je souhaite recevoir des offres personnalisées de la part d\'Atremoplus®',
      userNewsletterSubscribeError: 'Nous n\'avons pu vous enregistrer parmi nos abonnés, veuillez réessayer s\'il vous plaît.',
      userNewsletterSubscribeSuccess: 'Bravo ! Vous êtes bien inscrit à notre newsletter !',
      userSwitch: 'Changer l\'utilisateur',
      userValidForgotPasswordError: 'Impossible de vous envoyer le code de réinitialisation de mot de passe !',
      userValidForgotPasswordSuccess: 'Consultez votre boîte email pour utiliser votre code de confirmation afin de réinitialiser votre mot de passe !',

      valid: 'Valider',

      view: 'Voir',

      voucher: 'Code de réduction',
      voucherCodePlaceholder: 'Entrez votre code promo',
      voucherNotExistsError: 'Ce code promo n\'existe pas !',
      voucherNotValidError: 'Ce coupon ne peut être appliqué à votre commande !',
      vouchers: 'Réductions',

      yes: 'Oui',
      You: 'Vous',
      yourself: 'Vous',
  },
};


// comment: `user {name} {value, plural,
//       =0 {does not have any comments}
//       =1 {has # comment}
//       other {has # comments}
//     } (in real app this would be translated to French)`,
